import { motion } from "framer-motion";

export const dashboardPage = {
    hidden: { opacity: 0, y: 18 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.42, ease: "easeOut", staggerChildren: 0.07 }
    }
};

export const dashboardItem = {
    hidden: { opacity: 0, y: 18, scale: 0.98 },
    show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.36, ease: "easeOut" } }
};

export function MotionPanel({ className = "", children, ...props }) {
    return (
        <motion.div
            className={`zz-dashboard-panel ${className}`}
            variants={dashboardItem}
            initial="hidden"
            animate="show"
            whileHover={{ y: -3 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            {...props}
        >
            {children}
        </motion.div>
    );
}

export function MotionRow({ className = "", children, ...props }) {
    return (
        <motion.div
            className={className}
            variants={dashboardPage}
            initial="hidden"
            animate="show"
            {...props}
        >
            {children}
        </motion.div>
    );
}

export { motion };
